<template>
  <v-app>
    <router-view> </router-view>
    <Snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/snackbar.vue";

export default {
  components: {
    Snackbar,
  },

  name: "App",

  data() {
    return {
      // auth: ,
    };
  },
  computed: {
    auth() {
      return this.$store.getters.get_auth;
    },
  },
  mounted() {
    //this.$store.getter.auth define this getter in store/index
    //Commented
    if (!this.authenticated) {
      this.$router.push("/");
    }
  },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
    },
    logout() {
      this.authenticated = false;
    },
  },
};
</script>
<style lang="scss">
.align-items {
  align-items: center;
}
.header {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
  font-size: 18px;
}
.field_height.v-text-field .v-input__control .v-input__slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size.v-input .v-label {
  font-size: 12px;
}
.v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.headers_padding {
  padding-top: 30px;
  padding-bottom: 0px;
}
.btn {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
}
.something {
  background-color: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
}
</style>
